module.exports = __webpack_public_path__ + "static/media/Nidoking_gaussian2.1d015400.png";